import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import WillList from '../list/WillList';

import Box from '../components/Box';
import Button from '../components/Button';

import '../css/Deal.css';
import '../css/LdsDualRing.css';

const PurchasePage = ({
  dispatch,
  contracts,
  wills,
  owner,
  open,
  doingPurchaseDeal,
  doModal,
  doModalOthers,
  isInvalid,
  onClickEle,
  onClickDropdown,
  onClickForManipulation,
  handleChangeAD,
  willModalConfirm,
  willModalCancel
}) => {
  var dropDownList = [];
  const ownerList = [ "MY INTENTS", "OTHERS" ];
  const classNameDtl = open ? 'pv1 tc dropbtn init-bottom-rev mv2' : 'pv1 tc dropbtn init-bottom mv2';

  const [ modal, setModal ] = useState(null);
  const [ modalOthers, setModalOthers ] = useState(null);

  dropDownList = ownerList.map(i => {
    return (<li key={i} onClick={() => onClickEle(i)}><span>{i}</span></li>);
  });

  useEffect(() => {
    if (doModal.does)
      setModal(
        <div className='overlay'>
          <div className='modal-deal'>
            <Box className='flex justify-between ma2 pl2'>
              <h1 className='sans-serif f4 fw4 white'>Revokes Deal</h1>
              { doingPurchaseDeal &&
              <div className='flex items-center'>
                <div className='flex lds-dual-ring'></div>
                <div className='flex lds-dual-ring-text silver blinking'>This will take several seconds...</div>
              </div>
              }
            </Box>
            <table className='w-100 ph3 pv3'>
              <tbody>
                <tr>
                  <td className='sans-serif f5' style={{ width: '224px' }}>User Address</td>
                  <td className='sans-serif f5 white'>{doModal.userAddr}</td>
                </tr>
                <tr>
                  <td className='sans-serif f5'>Amount</td>
                  <td className='sans-serif f5 white'>{doModal.amount}</td>
                </tr>
                <tr>
                  <td className='sans-serif f5'>Price for a Token</td>
                  <td className='sans-serif f5 white'>{doModal.priceForToken}</td>
                </tr>
                <tr>
                  <td className='sans-serif f5'>Time to Indicate</td>
                  <td className='sans-serif f5 white'>{doModal.indicatedTime}</td>
                </tr>
              </tbody>
            </table>
            { doingPurchaseDeal
              ? <div className='flex justify-center mt3'>
                <Button className='mr1' disabled={true} onClick={() => willModalConfirm(owner, doModal)}>Confirm</Button>
                <Button className='ml1' disabled={true} onClick={() => willModalCancel(owner)}>Cancel</Button>
                </div>
              : <div className='flex justify-center mt3'>
                <Button className='mr1' onClick={() => willModalConfirm(owner, doModal)}>Confirm</Button>
                <Button className='ml1' onClick={() => willModalCancel(owner)}>Cancel</Button>
                </div>}
          </div>
        </div>
      );
    else
      setModal(null);
  }, [doModal, doingPurchaseDeal]);

  useEffect(() => {
    if (doModalOthers.does)
      setModalOthers(
        <div className='overlay'>
          <div className='modal-ledger'>
            <Box className='w-100 flex justify-between pv4 pl2'>
              <h1 className='mv2 sans-serif f4 fw4 white'>Confirms Deal</h1>
              { doingPurchaseDeal &&
              <div className='flex items-center'>
                <div className='flex lds-dual-ring'></div>
                <div className='flex lds-dual-ring-text silver blinking'>This will take several seconds...</div>
              </div>
              }
            </Box>
            <table className='w-100 ph3 pv3 bg-white'>
              <tbody>
                <tr>
                  <td className='sans-serif f5' style={{ width: '224px' }}>User Address</td>
                  <td className='sans-serif f5 white'>{doModalOthers.userAddr}</td>
                </tr>
                <tr>
                  <td className='sans-serif f5'>Amount</td>
                  <td className='sans-serif f5 white'>{doModalOthers.amount}</td>
                </tr>
                <tr>
                  <td className='sans-serif f5'>Price for a Token</td>
                  <td className='sans-serif f5 white'>{doModalOthers.priceForToken}</td>
                </tr>
                <tr>
                  <td className='sans-serif f5'>Time to Indicate</td>
                  <td className='sans-serif f5 white'>{doModalOthers.indicatedTime}</td>
                </tr>
              </tbody>
            </table>
            <div className='flex items-center'>
              <input
                type="text"
                placeholder="Amount for this deal"
                name="dealAmount"
                onChange={handleChangeAD}
                className='v-mid focus-outline ml3 mt2 mb2'
                style={{ borderColor: '#ffffff', width: '27%', maxWidth: "400px" }}
              />
              { isInvalid && <div className='ml3 san-serif red f5'>Invalid amount.</div> }
            </div>
            { doingPurchaseDeal
              ? <div className='flex justify-center mt3'>
                <Button className='mr1' disabled={true} onClick={() => willModalConfirm(owner, doModalOthers)}>Confirm</Button>
                <Button className='ml1' disabled={true} onClick={() => willModalCancel(owner)}>Cancel</Button>
                </div>
              : <div className='flex justify-center mt3'>
                <Button className='mr1' onClick={() => willModalConfirm(owner, doModalOthers)}>Confirm</Button>
                <Button className='ml1' onClick={() => willModalCancel(owner)}>Cancel</Button>
                </div>}
          </div>
        </div>
      );
    else
      setModalOthers(null);
  }, [doModalOthers, doingPurchaseDeal, isInvalid]);

  return (
    <div>
      {modal}
      {modalOthers}
      <Box className='mt4 mb2 mh4 pv3 ph4'>
        <h1 className='w-100 mt2 mb3 sans-serif f4 fw4 greenmod'>List of Intents to Sell</h1>
        <div className='dropdown'>
          <div onClick={onClickDropdown} className={classNameDtl} style={{ width: '22.5%', fontWeight: '400' }}>{owner}</div>
          { open && (<div className='dropdown-content'>
            <ul>
              {dropDownList}
              </ul>
            </div>)}
        </div>
      </Box>
      <WillList
        wills={wills}
        owner={owner}
        onClickForManipulation={onClickForManipulation}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  doingPurchaseDeal: state.purchase.doingPurchaseDeal
});

export default connect(mapStateToProps)(PurchasePage);
